<template>
  <v-container class="pa-0">
    <v-layout row class="pr-4">
      <span class="display-1 text-capitalize primary--text">{{ userFullName }}</span>
      <v-spacer></v-spacer>
      <document-upload-card documentType="resume"></document-upload-card>
    </v-layout>
    <v-divider></v-divider>
    <v-layout row wrap>
      <v-flex md3 sm12 order-md2>
        <profile-pic-card></profile-pic-card>
      </v-flex>
      <v-flex md9 sm12>
        <about-me-card></about-me-card>
      </v-flex>
    </v-layout>
    <skill-card></skill-card>
    <client-card></client-card>
    <certification-card></certification-card>
    <work-card></work-card>
    <education-card></education-card>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import EducationCard from '@/components/EducationCard'
import WorkCard from '@/components/WorkCard'
import CertificationCard from '@/components/CertificationCard'
import SkillCard from '@/components/SkillCard'
import ClientCard from '@/components/ClientCard'
import ProfilePicCard from '@/components/ProfilePicCard'
import DocumentUploadCard from '@/components/DocumentUploadCard'
import AboutMeCard from '@/components/AboutMeCard'
export default {
  name: 'Profile',
  components: {
    EducationCard,
    WorkCard,
    CertificationCard,
    SkillCard,
    ClientCard,
    ProfilePicCard,
    DocumentUploadCard,
    AboutMeCard
  },
  computed: {
    ...mapState('user', {
      user: 'user'
    }),
    userFullName () {
      if (this.user.middleName === null) {
        return this.user.firstName + ' ' + this.user.lastName
      } else {
        return this.user.firstName + ' ' + this.user.middleName + ' ' + this.user.lastName
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue